import REGEX from "../consts/regex";

import queryString from "qs";

export const parseQueryOf = (search: string) => {
  return queryString.parse(search.replace("?", ""));
};

// deprecated: replace this function with `parseQueryOf`
// because this function is insufficient for broader cases such as array query params.
export function getQueryStrings(): Map<string, string> {
  const result = new Map<string, string>();
  const raw = window.location.search;
  if (!raw) {
    return result;
  }
  const list = raw.slice(1).split("&");
  list.forEach((l) => {
    const index = l.indexOf("=");
    result.set(l.substring(0, index), l.substring(index + 1, l.length));
  });
  return result;
}

export function getHashes(raw: string): Array<string> {
  if (!raw) {
    return [];
  }
  const array = raw.split("#");
  if (array.length > 0) {
    array.shift();
  }
  return array;
}

// 通常のエントリーポイント
export function checkGrafferUrl(url: string | undefined): boolean {
  if (!url) {
    return true;
  }

  // local envはproduct envと許可パターンが全く違うため分岐
  if (process.env.NEXT_PUBLIC_ENVIRONMENT === "local") {
    return true;
  }
  return _checkGrafferUrl(url);
}

// テストのための公開
export function _checkGrafferUrl(_url: string): boolean {
  // `/services` 形式のpath指定は許可する
  if (_url.match(/^\/\w+$/)) {
    return true;
  }

  const url = new URL(_url);
  // httpsは必須（httpへのリダイレクト時にキャッシュ汚染を受ける可能性があるため）
  if (url.protocol !== "https:") {
    return false;
  }
  // portの指定は受け付けない
  if (url.port !== "") {
    return false;
  }
  // usernameの指定は受け付けない
  if (url.username !== "") {
    return false;
  }
  // passwordの指定は受け付けない
  if (url.password !== "") {
    return false;
  }
  // hostnameはgraffer.jp以外受け付けない
  if (!url.hostname.match(REGEX.GRAFFER_DOMAIN)) {
    return false;
  }
  return true;
}
